import React from 'react';
import './adminUi.css';

export function AdminContentCard(props: {
    title?: string;
    description?: React.ReactNode;
    actions?: React.ReactNode;
    children: React.ReactNode;
}) {
    return (
        <section className="adminContentCard">
            {props.title || props.description || props.actions ? (
                <div className="adminContentCardHeader">
                    <div>
                        {props.title ? <h2 className="adminContentCardTitle">{props.title}</h2> : null}
                        {props.description ? (
                            <div className="adminContentCardDescription">{props.description}</div>
                        ) : null}
                    </div>

                    {props.actions ? <div>{props.actions}</div> : null}
                </div>
            ) : null}

            {props.children}
        </section>
    );
}